__turbopack_context__.v({
  "article-eyebrow": "caWyXq_article-eyebrow",
  "eyebrow-link": "caWyXq_eyebrow-link",
  "image": "caWyXq_image",
  "main-article-info": "caWyXq_main-article-info",
  "main-article-title": "caWyXq_main-article-title",
  "main-articles-button": "caWyXq_main-articles-button",
  "main-articles-category": "caWyXq_main-articles-category",
  "main-articles-main": "caWyXq_main-articles-main",
  "main-articles-main-image": "caWyXq_main-articles-main-image",
  "main-articles-title": "caWyXq_main-articles-title",
  "play-button": "caWyXq_play-button",
  "play-button-secondary": "caWyXq_play-button-secondary",
  "secondaries-articles": "caWyXq_secondaries-articles",
  "secondaries-articles-item": "caWyXq_secondaries-articles-item",
  "secondaries-articles-item-info": "caWyXq_secondaries-articles-item-info",
  "secondaries-articles-item-title": "caWyXq_secondaries-articles-item-title",
  "secondary-image-container": "caWyXq_secondary-image-container",
});
